import api, { ResponsePayloadWithData } from '.';
import type { Status } from '../utils/results';
import { ContentType } from './medialink';

export interface ScoreBase {
  maximum: number;
  achievable: number;
  achieved: number;
  amountOfItems: number;
  status?: Status;
}

export interface MyAssignment {
  id: string;
  name: string;
  from: string;
  to: string;
  moduleId: string;
  moduleName: string;
  superModuleId: string;
  subjectName: string;
  materialId: string;
  materialType: 'user-material' | 'medialink';
  contentType?: ContentType;
  score: ScoreBase & {
    achievedAt?: string;
  };
  sharer: {
    firstName: string;
    lastName: string;
  };
  nodeId: string;
  unachievable: boolean;
  hierarchy: {
    id: string;
    title: string;
    prefix?: string;
  }[];
}

export type AssignmentBase = {
  id: string;
  name: string;
  from: string;
  to: string;
  materialId: string;
  materialType: 'user-material' | 'medialink';
  moduleId: string;
  score: ScoreBase;
  contentType?: ContentType;
  schoolName: string;
  groupName?: string;
  repeatable?: boolean;
  href?: string;
  hierarchy: {
    id: string;
    title: string;
    prefix?: string;
  }[];
};

export type ExpiredAssignment = AssignmentBase & {
  state: 'expired';
  allowReview: boolean;
  sessionId: string;
  score: ScoreBase & {
    achievedAt: string;
  };
};

export type CompletedAssignment = AssignmentBase & {
  state: 'completed';
  allowReview: boolean;
  allowRepeat: boolean;
  sessionId: string;
  score: ScoreBase & {
    achievedAt: string;
  };
  needsGrading: boolean;
  owner: {
    firstName: string;
    lastName: string;
  };
  schoolName: string;
  groupName?: string;
};

export type OpenAssignment = AssignmentBase & {
  state: 'open';
  score: ScoreBase & {
    achievedAt?: string;
  };
  owner: {
    firstName: string;
    lastName: string;
  };
  schoolName: string;
  groupName?: string;
};

export async function getMyAssignments() {
  const {
    data: { data },
  } = await api.get<ResponsePayloadWithData<MyAssignment[]>>(
    `/studio/user/assignments?studioGroup=${process.env.REACT_APP_P_STUDIO_GROUP}`,
  );

  return data;
}
